import  { useState} from 'react';
import './App.css';
import   WindowPortal   from './windowPortalTwo.js';
import Form from './Form.jsx';
import CallMadeIcon from '@material-ui/icons/CallMade';
import InputsPage from './inputsPage';
import './FullDocView.css';





export default function DocPad() {
  const [open, setOpen] = useState(false)



  function handleClick() {
    const HTML = document.documentElement
    HTML.classList.contains("slide") ? HTML.classList.remove("slide") : HTML.classList.add("slide")
  }

  const HandleOpen = (e) => { 
    e.preventDefault();
    setOpen(!open)
    
  }

   function displayWindowedDocPad() {
     if(!open) {
       return null;
     }
     return (
      <WindowPortal title="Magic Window">
              <div className="padWrapAlt" >
                <div className="padInnerAlt">
                    <div className="padInnerContentAlt">
                        <Form />
                    </div>
                </div>
                <div className="padNavWrapAlt"> 
                <div className="padNavCenterAlt"><b className="padNavCenterTitle">Preview</b><b className="padNavInd"></b></div> 
                {/* <span className="padNavRightAlt"><b className="padNavSep" >&#10063;</b></span> */}
            </div>
        </div> 
        </WindowPortal>
      )
   }

 
  return (
    <div className="App">
      <div className="inputPageWrap">
        <div className="inputsWrap">
          <InputsPage />
        </div>
      </div>
      <div className="padWrap">
        <div className="padNavWrap"> 
          <div className="padNavCenter" onClick={handleClick}><b className="padNavCenterTitle">Preview</b><b className="padNavInd"></b></div> 
          <span className="padNavRight" onClick={e => HandleOpen(e)}><b className="callMadeIcon"><CallMadeIcon /></b></span>
        </div>
        <div className="padInner">
          <div className="padInnerContent">
            <Form />
          </div>
        </div>
      </div> 
       {displayWindowedDocPad()}
    </div>
  );
}